import React from 'react';
import { SetTeamsModal } from './set-teams-modal.component';
import { useSetTeamsModalService } from './set-teams-modal.service';
import type { SetTeamsModalContainerProps } from './set-teams-modal.types';

export const SetTeamsModalContainer = (props: SetTeamsModalContainerProps) => {
  const serviceProps = useSetTeamsModalService(props);
  return <SetTeamsModal {...serviceProps} />;
};
